<script>
import CsnuListVue from './CsnuList.vue';

export default {
  name: 'OfacList',
  extends: CsnuListVue,
  data: () => ({
    headers: [
      {
        text: 'Primeiro nome',
        value: 'firstName',
      },
      {
        text: 'Sobrenome',
        value: 'lastName',
      },
      {
        text: 'title',
        value: 'title',
      },
      {
        text: 'Tipo de documento',
        value: 'sdnType',
      },
      {
        text: 'remarks',
        value: 'remarks',
      },
    ],
  }),
};
</script>
